import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/symbol';
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'core-js/fn/number/max-safe-integer';
import 'core-js/fn/number/min-safe-integer';
import 'core-js/fn/object/entries';
import 'core-js/fn/string/ends-with';
import 'core-js/fn/string/includes';
import 'core-js/fn/string/starts-with';
import 'raf/polyfill';

import {
  ConnectedRouter,
  connectRouter,
  routerMiddleware
} from 'connected-react-router';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';

import DragAndDrop from './components/container/DragAndDrop';
import Modal from 'react-modal';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import React from 'react';
import { Route } from 'react-router-dom';
import Shift from './components/container/Shift';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createBrowserHistory } from 'history';
import { createLogger } from 'redux-logger';
import { render } from 'react-dom';
import shiftReducer from './state';
import sessionStorage from 'redux-persist/lib/storage/session';
import thunk from 'redux-thunk';
import reduxUnhandledAction from 'redux-unhandled-action';
import promiseMiddleware from 'redux-promise-middleware';

console.log = process.env.NODE_ENV === 'production' ? ()=>{} : console.log;
console.log("==============")
console.log(process.env)

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

const persistConfig = {
  key: 'shift',
  storage: sessionStorage,
  blacklist: ['status']
};

const rootReducer = connectRouter(history)(
  combineReducers({
    shift: persistReducer(persistConfig, shiftReducer)
  })
);

const sharedMiddleWares = process.env.NODE_ENV === 'production'
  ?[
  routerMiddleware(history),
  thunk,
  promiseMiddleware({
    promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'ERROR']
  })]: [
    routerMiddleware(history),
    thunk,
    promiseMiddleware({
      promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'ERROR']
    }),
    createLogger({
      collapsed: true
    })
  ];

const store =
  process.env.NODE_ENV === 'production'
    ? createStore(rootReducer, applyMiddleware(...sharedMiddleWares))
    : createStore(
        rootReducer,
        composeWithDevTools(
          applyMiddleware(
            reduxUnhandledAction(({ type }) =>
              console.warn(`action ${type} did not mutate the state!`)
            ),
            require('redux-immutable-state-invariant').default(),
            ...sharedMiddleWares
          )
        )
      );

const persistor = persistStore(store);

const getPersistor = () => persistor;
const getStore = () => store;
export {
  getStore,
  getPersistor
};
export default {
  getStore,
  getPersistor
};

render(
  <Provider store={store}>
    <DragAndDrop>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={history}>
          <Route component={Shift} />
        </ConnectedRouter>
      </PersistGate>
    </DragAndDrop>
  </Provider>,

  document.getElementById('root')
);

Modal.setAppElement('#root');




// WEBPACK FOOTER //
// ./src/index.js